module.exports = __webpack_public_path__ + "static/media/1005453.dc8fab55.jpg";